import { useEffect } from 'react';

interface DocumentLangProps {
  /** BCP 47 tag of the section's current locale. */
  lang: string;
}

/**
 * Keeps <html lang> in step with the route's locale after client-side navigation.
 * React has no <html> attribute API; the prerender sets the initial value per file.
 */
export const DocumentLang = ({ lang }: DocumentLangProps) => {
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return null;
};
